<template>
  <div class="register-page">
    <LoginBackground />
    <!-- Navigation bar -->
    <nav class="main-nav">
      <a href="/">
        <div class="logo">
        <span class="logo-symbol"><img src="https://xtsq-oss-hb.oss-cn-beijing.aliyuncs.com/sunrise-images/sunrise-logo.png" width="60" height="60" alt="小晖AI客服" style="border-radius: 10%;"/></span>
        <span>小晖AI客服平台</span>
      </div>
      </a>
    </nav>

    <!-- Registration form -->
    <div class="register-wrapper">
      <div class="register-card">
        <h1 class="register-title">账户注册</h1>

        <form @submit.prevent="handleSubmit">
          <!-- Contact Phone -->
          <div class="form-group">
            <label for="contactPhone"><span class="required-asterisk">*</span>手机号</label>
            <input
              v-model="form.contactPhone"
              type="tel"
              id="contactPhone"
              pattern="1[3-9]\d{9}"
              required
              placeholder="将作为登录的唯一标识"
              @blur="validatePhone">
          </div>

          <!-- SMS Verification Code -->
          <div class="form-group">
            <label for="sms-code"><span class="required-asterisk">*</span>短信验证码</label>
            <div class="sms-group">
              <input
                id="sms-code"
                v-model="form.code"
                type="text"
                required
                placeholder="6位验证码"
                maxlength="6">
              <button
                type="button"
                class="sms-btn"
                :disabled="isCountingDown || !isPhoneValid"
                @click="sendSMSCode">

                <span v-if="!loading_sms"> {{ countdown > 0 ? `${countdown}s后重发` : '获取验证码' }}</span>
    <span v-else>
      <i class="el-icon-loading"></i> 发送中...
    </span>
              </button>
            </div>
            <p v-if="smsError" class="error-message">{{ smsError }}</p>
          </div>

          <p class="form-note">欢迎您注册本平台账户，注册后必须通过实名认证才能拥有自己的专属AI客服。</p>
          <button type="submit" class="submit-btn" :disabled="loading_register">
            <span v-if="!loading_register">提交注册申请</span>
            <span v-else>
      <i class="el-icon-loading"></i> 提交中...
    </span>
          </button>
        </form>

        <div class="login-link">
          <input type="checkbox" id="checkbox1" v-model="agreement" value="Jack">
    <label for="checkbox1">我已阅读并同意 </label><span class="link" @click="HandleLicense">小晖AI客服平台用户服务协议</span> 、 <span @click="HandleAcceptable" class="link">可接受使用政策</span>和<span @click="HandlePrivacy" style="margin-right:30px" class="link">隐私政策</span>

          已有账户？<router-link to="/login">前往登录</router-link>
        </div>
      </div>
    </div>

      <!-- 服务协议对话框 -->
      <el-dialog title="小晖AI客服平台用户服务协议" :visible.sync="open_licence" width="80%" append-to-body>
      <div style="height: 400px; overflow: auto;">
        <div v-html="licenceContent"></div>
      </div>
    </el-dialog>
      <!-- 隐私政策对话框 -->
      <el-dialog title="小晖AI客服平台隐私政策" :visible.sync="open_privacy" width="80%" append-to-body>
      <div style="height: 400px; overflow: auto;">
        <div v-html="privacyContent"></div>
      </div>
    </el-dialog>
      <!-- 可接受使用政策对话框 -->
      <el-dialog title="小晖AI客服平台可接受使用政策" :visible.sync="open_acceptable" width="80%" append-to-body>
      <div style="height: 400px; overflow: auto;">
        <div v-html="acceptableContent"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LoginBackground from '@/components/LoginBackground.vue'
import { postRegister } from '@/api/auth/register'
import { send_sms_code } from '@/api/common'
import {getUserAgeement, getAcceptable, getPrivacy} from '@/api/tenant/agreement'
export default {
  name: 'RegisterView',
  components: {
    LoginBackground,

  },
  data() {
    return {
      form: {
        companyName: '',
        socialCreditCode: '',
        contactPerson: '',
        contactPhone: '',
        code: '',
        password: '',
        confirmPassword: '',
        licenceFile: null
      },
      agreement: false,
      open_licence: false,
      open_privacy: false,
      open_acceptable: false,
      privacyContent: '', // 隐私政策内容
      loading_sms: false, // 加载状态
      previewImage: null,
      loading_register: false,
      countdown: 0,
      countdownTimer: null,
      isPhoneValid: false,
      smsError: '',
      apiBaseUrl: process.env.VUE_APP_API_BASE_URL || 'http://127.0.0.1:10001',
      //密码复杂度校验
      passwordError: '',
      passwordMatchError: '',
      passwordRules: {
        minLength: 6,
        maxLength: 20,
        requireLetter: true,
        requireNumber: true,

        // 可扩展：requireSpecialChar: true
      },
      licenceContent:"-",
      acceptableContent: "-"
    }
  },
  computed: {
    isCountingDown() {
      return this.countdown > 0
    }
  },
  created() {
    this.checkCountdown();
/*    this.licenceContent="<p class='text'>为了保护网络信息安全，保障公民、法人和其他组织的合法权益，维护国家安全和社会公共利益，根据国家法律法规以及全国人大常委会的相关规定，北京启明晨晖信息技术有限公司（以下简称“我们”或“启明晨晖”）制定并按照本协议提供网络服务。请您在注册成为小晖AI平台用户前务必仔细阅读本协议，请您务必审慎阅读、充分理解各条款内容，";
    this.licenceContent+="<b>重要提示：</b>请在使用本平台前仔细阅读本《用户服务协议》（下称\"本协议\"）。本协议是您（下称\"用户\"或\"您\"）与平台运营方（下称\"我们\"或\"平台\"）之间就使用小晖AI客服平台（下称\"本平台\"）相关服务所订立的具有法律效力的协议。<b>一旦您以任何形式使用本平台服务，即表示您已充分阅读、理解并同意接受本协议的全部条款和条件，以及我们已公布或将来可能公布并包含在本协议中的各项政策、规则和声明的约束。如果您不同意本协议的任何条款，请立即停止访问或使用本平台。</b></p>";
    this.licenceContent+="<p class='title1'><b>第一章 总则</b></p>";
    this.licenceContent+="<p class='title2'><b>第1条 协议主体与范围</b></p>";
    this.licenceContent+="<p class='text'>1.1 本协议由平台运营方与使用本平台服务的任何用户共同签订。平台运营方是指提供本平台技术服务和运营支持的法律实体，即北京启明晨晖信息技术有限公司。</p>";
    this.licenceContent+="<p class='text'>1.2 本协议适用于本平台提供的包括但不限于AI客服机器人、用户团队管理、知识库管理、发布AI客服中心、部署AI客服席位、AI客服数据分析等在内的全部产品和服务（下统称\"本服务\"）。</p>";
    this.licenceContent+="<p class='text'>1.3 用户是指通过有效注册程序或通过其他合法授权方式使用本服务的个人、法人或其他组织。用户可能需要根据不同服务类型进一步区分为“未认证用户”、“租户管理员”、“租户员工用户”等，本协议项下的权利义务规定适用于所有用户类型，除非另有明确约定。</p>";
    this.licenceContent+="<p class='title2'><b>第2条 协议变更与修改</b></p>";
    this.licenceContent+="<p class='text'>2.1 我们有权根据需要不时地修改本协议条款。如条款发生变更，我们将通过平台公告、站内信、电子邮件或其他适当方式提前通知用户，变更后的条款自公布之日起生效。</p>";
    this.licenceContent+="<p class='text'>2.2 如用户不同意相关变更，有权停止使用本服务。如用户继续使用本服务，则视为用户已接受修改后的协议。</p>";
    this.licenceContent+="<p class='title2'><b>第3条 其他协议文件</b></p>";
    this.licenceContent+="<p class='text'>3.1 本协议包括《隐私政策》、《数据保护协议》、《可接受使用政策》等附属协议（下统称\"附属协议\"），这些附属协议通过引用的方式纳入本协议，与本协议具有同等法律效力。</p>";
    this.licenceContent+="<p class='text'>3.2 如本协议与附属协议约定不一致的，应以附属协议的特别约定为准；不同附属协议之间约定不一致的，应以发布在后的协议为准。</p>";
    this.licenceContent+="<p class='title1'><b>第二章 账户注册与管理</b></p>";
    this.licenceContent+="<p class='title2'><b>第4条 注册资格</b></p>";
    this.licenceContent+="<p class='text'>4.1 用户确认，在开始注册程序使用本服务前，应当具备中华人民共和国法律规定的与用户行为相适应的民事行为能力。</p>";
    this.licenceContent+="<p class='text'>4.2 如用户为不满18周岁的未成年人，应在监护人监护、指导下共同阅读本协议，并在获得监护人对本协议全部条款的完全同意后使用本服务。如用户为无民事行为能力人或限制民事行为能力人，则应由其监护人代理注册或使用本服务。</p>";
    this.licenceContent+="<p class='title2'><b>第5条 注册信息</b></p>";
    this.licenceContent+="<p class='text'>5.1 用户应按本平台提示准确提供注册信息并完成实名认证，确保提供的资料真实、准确、完整、合法有效。如用户提供的注册信息和实名认证信息不合法、不真实、不准确或不完整，平台有权暂停或终止向用户提供全部或部分服务，用户需承担由此产生的全部责任。</p>";
    this.licenceContent+="<p class='text'>5.2 用户注册或实名认证信息发生变化的，应及时进行更新。因用户未及时更新信息导致本服务无法提供或提供时发生任何错误，平台不承担任何责任。</p>";
    this.licenceContent+="<p class='title2'><b>第6条 账户安全</b></p>";
    this.licenceContent+="<p class='text'>6.1 用户注册成功后，将获得一个账户（下称\"账户\"）并为其设置相应的密码。该账户和密码由用户负责保管。用户应对其账户进行的所有活动和事件负法律责任。</p>";
    this.licenceContent+="<p class='text'>6.2 用户同意：(a)如发现任何非法使用账户或存在安全漏洞的情况，应立即通知平台；及(b)确保在每个上网时段结束时，以正确方式退出账户。平台无法也不会对因用户未能遵守本款规定而发生的任何损失或损毁负责。</p>";
    this.licenceContent+="<p class='title2'><b>第7条 多租户管理</b></p>";
    this.licenceContent+="<p class='text'>7.1 本平台采用多租户架构，不同租户之间的数据和配置相互独立。用户作为特定租户的管理员或成员，仅可访问该租户授权范围内的数据和功能。</p>";
    this.licenceContent+="<p class='text'>7.2 租户管理员有权管理该租户下的用户权限分配、数据访问范围设置等。租户管理员的操作视为该租户的授权行为，由该租户承担相应法律责任。</p>";
    this.licenceContent+="<p class='title1'><b>第三章 服务内容</b></p>";
    this.licenceContent+="<p class='title2'><b>第8条 服务概述</b></p>";
    this.licenceContent+="<p class='text'>8.1 本平台是基于人工智能技术的多租户客服解决方案，主要功能包括但不限于：</p>";
    this.licenceContent+="<p class='text'>(1) AI客服机器人：提供7x24小时自动问答服务；</p>";
    this.licenceContent+="<p class='text'>(2) 多渠道接入：支持网站、微信公众号、小程序等多渠道客户咨询统一管理；</p>";
    this.licenceContent+="<p class='text'>(3)团队管理：特定类型的租户管理员可以创建团队、并为员工用户指定角色，辅助管理员完成对AI客服机器人的配置和管理；</p>";
    this.licenceContent+="<p class='text'>(4) 知识库管理：每个租户都可以拥有平台提供的知识库，并将AI客服机器人需要的相关文档上传至知识库；</p>";
    this.licenceContent+="<p class='text'>(5) 训练和测试AI客服机器人：您上传文档到知识库的同时，平台会自动使用相关文档训练AI客服机器人，使其能够消化、理解文档内容。上传所有必需的文档后，您可以与AI客服机器人进行对话、对其进行测试。如果发现有表现不当之处，则分析原因、完善知识库文档；</p>";
    this.licenceContent+="<p class='text'>(6) 发布AI客服中心：AI客服中心是知识库的一个副本，它为特定的某个应用的AI客服机器人提供文档支持。租户可以独立管理和配置AI客服中心，而不影响主知识库的内容；</p>";
    this.licenceContent+="<p class='text'>(7)部署AI客服席位：每个AI客服中心都可以包含若干个AI客服席位，每个AI客服席位绑定到某个特定的应用（网站、公众号、小程序）。它们对不同应用的用户提供同样的客服服务；</p>";
    this.licenceContent+="<p class='text'>(8) 数据分析：提供AI客服对话分析、服务质量评估、以及数据统计等功能；</p>";
    this.licenceContent+="<p class='title2'><b>第9条 服务标准</b></p>";
    this.licenceContent+="<p class='text'>9.1 我们将按照行业标准合理努力确保本服务的连续性和稳定性。但由于技术发展的特殊性、计算机病毒、黑客攻击、系统不稳定、用户所在位置、用户关机、通信线路质量、互联网服务提供商质量差异以及其他任何不可抗力等原因，用户理解并同意平台不承担由此给用户造成的损失。</p>";
    this.licenceContent+="<p class='text'>9.2 我们保留随时变更、中断或终止部分或全部服务的权利。如变更、中断或终止的服务属于免费服务，我们无需通知用户，也无需对任何用户或任何第三方承担任何责任。</p>";
    this.licenceContent+="<p class='title2'><b>第10条 服务限制</b></p>";
    this.licenceContent+="<p class='text'>10.1 用户理解并同意，本服务可能因定期或不定期的维护而中断，我们应尽可能提前进行通告。</p>";
    this.licenceContent+="<p class='text'>10.2 由于通信线路、网络安全、网络带宽等因素的影响，以及第三方服务平台（如云服务提供商、AI模型提供商）的原因，本平台不保证服务不会中断，也不保证服务的及时性和安全性。</p>";
    this.licenceContent+="<p class='title1'><b>第四章 用户权利义务</b></p>";
    this.licenceContent+="<p class='title2'><b>第11条 用户权利</b></p>";
    this.licenceContent+="<p class='text'>11.1 注册用户在遵守本协议的前提下，有权使用本平台提供的各项服务。</p>";
    this.licenceContent+="<p class='text'>11.2 用户有权随时查询、更正自己的实名认证信息，实名认证信息的变更必须通过平台方的审核才能生效。</p>";
    this.licenceContent+="<p class='text'>11.3 用户有权根据本平台相关规则，享受我们提供的技术支持和售后服务。</p>";
    this.licenceContent+="<p class='title2'><b>第12条 用户义务</b></p>";
    this.licenceContent+="<p class='text'>12.1 用户不得利用本服务从事任何违反法律法规、政策或侵犯第三方权益的行为，包括但不限于：</p>";
    this.licenceContent+="<p class='text'>(1) 反对宪法确定的基本原则的；</p>";
    this.licenceContent+="<p class='text'>(2) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>";
    this.licenceContent+="<p class='text'>(3) 损害国家荣誉和利益的；</p>";
    this.licenceContent+="<p class='text'>(4) 煽动民族仇恨、民族歧视，破坏民族团结的；</p>";
    this.licenceContent+="<p class='text'>(5) 破坏国家宗教政策，宣扬邪教和封建迷信的；</p>";
    this.licenceContent+="<p class='text'>(6) 散布谣言，扰乱社会秩序，破坏社会稳定的；</p>";
    this.licenceContent+="<p class='text'>(7) 散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</p>";
    this.licenceContent+="<p class='text'>(8) 侮辱或者诽谤他人，侵害他人合法权益的；</p>";
    this.licenceContent+="<p class='text'>(9) 含有法律、行政法规禁止的其他内容的。</p>";
    this.licenceContent+="<p class='text'>12.2 用户不得从事任何可能干扰、破坏本服务或相关网络服务的行为，包括但不限于：</p>";
    this.licenceContent+="<p class='text'>(1) 未经允许，进入平台计算机信息网络系统或者使用计算机信息网络系统资源；</p>";
    this.licenceContent+="<p class='text'>(2) 未经允许，对计算机信息网络功能进行删除、修改或者增加；</p>";
    this.licenceContent+="<p class='text'>(3) 未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加；</p>";
    this.licenceContent+="<p class='text'>(4) 故意制作、传播计算机病毒等破坏性程序；</p>";
    this.licenceContent+="<p class='text'>(5) 其他危害计算机信息网络安全的行为。</p>";
    this.licenceContent+="<p class='text'>12.3 用户理解并同意，其在使用本服务过程中产生的内容（包括但不限于实名认证信息、对话记录、知识库内容、上传的文件等）由其自行负责。用户应对其内容的合法性、真实性、准确性负责，并确保不侵犯任何第三方的合法权益。</p>";
    this.licenceContent+="<p class='text'>12.4 用户理解并同意，其应自行承担使用本服务所需的设备（如个人电脑、手机、及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）。</p>";
    this.licenceContent+="<p class='title1'><b>第五章 知识产权</b></p>";
    this.licenceContent+="<p class='title2'><b>第13条 平台知识产权</b></p>";
    this.licenceContent+="<p class='text'>13.1 本平台的所有知识产权，包括但不限于软件、算法、系统架构、界面设计、数据库、文档、商标、标识等，均归启明晨晖所有，受法律保护。</p>";
    this.licenceContent+="<p class='text'>13.2 用户不得复制、修改、改编、翻译、反编译、反汇编、反向工程、分解或试图从本服务中提取源代码，或创建本服务的衍生作品，除非法律明确允许或平台书面授权。</p>";
    this.licenceContent+="<p class='title2'><b>第14条 用户内容授权</b></p>";
    this.licenceContent+="<p class='text'>14.1 用户在本平台上传、发布或传输的内容，用户授予平台一项全球性、免许可费、非独占性的许可，使平台可以在提供、维护和改进服务所必需的范围内使用、复制、修改、改编、发布、翻译和展示此类内容。</p>";
    this.licenceContent+="<p class='text'>14.2 该许可是平台提供服务所必需的，例如用于存储内容、在用户不同设备间同步内容、将内容转换为不同格式等。该许可在用户停止使用服务后，在平台处理用户内容所需的合理期限内继续有效。</p>";
    this.licenceContent+="<p class='title2'><b>第15条 AI生成内容</b></p>";
    this.licenceContent+="<p class='text'>15.1 用户理解并同意，通过本平台AI功能生成的内容（下称\"AI生成内容\"）是基于用户输入和平台算法共同产生的结果。</p>";
    this.licenceContent+="<p class='text'>15.2 对于AI生成内容的知识产权归属，如无特殊约定，用户可在遵守本协议的前提下使用该内容，但平台保留对算法模型和基础技术的所有权。</p>";
    this.licenceContent+="<p class='title1'><b>第六章 数据保护与隐私</b></p>";
    this.licenceContent+="<p class='title2'><b>第16条 数据保护原则</b></p>";
    this.licenceContent+="<p class='text'>16.1 平台将按照《中华人民共和国网络安全法》、《中华人民共和国数据安全法》、《中华人民共和国个人信息保护法》等适用法律法规的要求，采取合理措施保护用户数据安全。</p>";
    this.licenceContent+="<p class='text'>16.2 平台将按照《隐私政策》的约定收集、使用、存储、处理和传输用户的个人信息。</p>";
    this.licenceContent+="<p class='title2'><b>第17条 多租户数据隔离</b></p>";
    this.licenceContent+="<p class='text'>17.1 平台采用技术手段确保不同租户间的数据隔离，未经授权，一个租户无法访问其他租户的数据。</p>";
    this.licenceContent+="<p class='text'>17.2 平台管理员仅在必要时（如系统维护、故障排查等）可能访问用户数据，但将遵守严格的数据访问审批和审计制度。</p>";
    this.licenceContent+="<p class='title2'><b>第18条 数据备份与恢复</b></p>";
    this.licenceContent+="<p class='text'>18.1 平台将按照行业标准对用户数据进行定期备份，但用户理解并同意，平台不保证备份的完整性和可恢复性。</p>";
    this.licenceContent+="<p class='text'>18.2 用户应自行备份其重要数据，平台不对用户数据丢失承担赔偿责任。</p>";
    this.licenceContent+="<p class='title2'><b>第19条 数据处理协议</b></p>";
    this.licenceContent+="<p class='text'>19.1 如用户使用本服务涉及处理个人数据，用户应确保其处理活动符合适用数据保护法律法规的要求。</p>";
    this.licenceContent+="<p class='text'>19.2 平台将作为数据处理者，按照用户的指示处理数据，双方权利义务详见《数据保护协议》。</p>";
    this.licenceContent+="<p class='title2'><b>第20条 服务费用</b></p>";
    this.licenceContent+="<p class='text'>20.1 本平台部分服务是免费的，部分服务需要付费使用。具体收费标准和规则以平台公示或双方另行签订的协议为准。</p>";
    this.licenceContent+="<p class='text'>20.2 我们有权根据运营需要调整收费标准，调整后的收费标准将在公示后生效。</p>";
    this.licenceContent+="<p class='title2'><b>第21条 支付方式</b></p>";
    this.licenceContent+="<p class='text'>21.1 用户可以选择平台支持的支付方式支付服务费用。</p>";
    this.licenceContent+="<p class='text'>21.2 用户应及时足额支付服务费用，如逾期未支付，平台有权暂停或终止提供服务。</p>";
    this.licenceContent+="<p class='title2'><b>第22条 发票与税款</b></p>";
    this.licenceContent+="<p class='text'>22.1 用户支付费用后，可按照平台规则申请开具发票。</p>";
    this.licenceContent+="<p class='text'>22.2 所有费用均不含税，如适用法律法规要求代扣代缴税款，用户应按照相关规定办理。</p>";

    this.licenceContent+="<p class='title2'><b>第23条 退款政策</b></p>";
    this.licenceContent+="<p class='text'>23.1 <b>原则上不接受退款</b></p>";
    this.licenceContent+="<p class='text'>鉴于本平台提供的服务属于虚拟商品和在线服务，具有非物质性、即时消耗性和不可回收性等特点，且用户已经过长期试用，已充分了解本平台的功能和运行情况。用户知悉并同意：除本协议另有明确约定外，平台<b>不接受其他形式的退款申请</b>。</p>";
    this.licenceContent+="<p class='text'>23.2 <b>不适用退款的情形</b></p>";
    this.licenceContent+="<p class='text'>以下情形明确不适用退款：</p>";
    this.licenceContent+="<p class='text'>(1) 除本协议23.3约定的例外情形外，用户购买套餐或加油包后，平台不接受主动退款申请。用户已使用的服务时长或已消耗的流量包等不予退还；</p>";
    this.licenceContent+="<p class='text'>(2) 用户因自身决策失误（包括但不限于选错套餐、多购买、重复购买等）申请退款；";
    this.licenceContent+="<p class='text'>(3) 用户因未能充分了解产品功能、使用限制或服务范围而申请退款；";      
    this.licenceContent+="<p class='text'>(4) 用户因自身业务调整、停业、转型等原因不再需要使用本服务；";      
    this.licenceContent+="<p class='text'>(5) 用户违反本协议或相关附属协议导致账户被限制、暂停或终止；";      
    this.licenceContent+="<p class='text'>23.3 <b>可申请退款的例外情形</b></p>";
    this.licenceContent+="<p class='text'>仅在发生以下因<b>平台方根本违约，导致本合同目的完全无法实现</b>的极端情形时，用户可提出解除合同并申请退款： </p>";
    this.licenceContent+="<p class='text'>（1）<b>持续重大中断</b>：因平台自身原因（不可抗力及第三方原因除外），导致您所购服务的<b>全部核心功能完全不可用</b>，且该状态<b>持续超过15个连续自然日</b>，用户通知平台后平台未在合理时间内修复；</p>";
    this.licenceContent+="<p class='text'>（2）平台单方重大变更：平台在服务期内，单方面、永久性地停止运营您所购买的核心服务，且未提供基本等同或更高的替代服务方案。</p>";      
    this.licenceContent+="<p class='text'>23.4 <b>退款计算与处理</b></p>";    
    this.licenceContent+="<p class='text'>（1）  符合第23.3条退款情形的，退款金额计为剩余服务周期对应的费用。退款后，本协议终止。</p>";       
    this.licenceContent+="<p class='text'>（2） 除第23.3条约定的情形外，用户因任何其他原因（包括但不限于对服务不满意、业务需求变化、使用频率低等）要求解除合同并退款的，平台均不予支持。对于因平台未达服务标准但未构成第23.3条根本违约的情形，平台将以服务抵扣的形式与用户协商补偿。</p>";    
    this.licenceContent+="<p class='text'>23.5 <b>促销活动特殊规定</b></p>";   
    this.licenceContent+="<p class='text'>通过促销活动、折扣码、优惠券等方式获得的折扣金额不予退还。如用户参与【免费试用】活动，试用期内不涉及退款。</p>";     
    this.licenceContent+="<p class='text'>23.6 <b>用户确认</b></p>";   
    this.licenceContent+="<p class='text'>用户点击购买、支付费用或以其他方式使用付费服务的，即视为已充分阅读、理解并同意本第23条的全部内容。平台已在购买页面通过显著方式提示【不支持无理由退款】，用户确认已注意到该提示。</p>";        
    this.licenceContent+="<p class='title1'><b>第八章 免责声明</b></p>";
    this.licenceContent+="<p class='title2'><b>第24条 服务【按原样】提供</b></p>";    
    this.licenceContent+="<p class='text'>24.1 本服务以【按原样】和【当前可用】的基础提供。用户理解互联网服务存在固有特性，平台<b>不就服务作出任何明示或默示的、超出本协议明确约定的保证</b>。对于因任何<b>不可抗力、第三方服务故障、网络拥堵、用户自身设备或操作原因、或日常必需的合理维护</b>所导致的服务中断、延迟或数据丢失，平台不承担责任，但应尽合理努力减少影响。</p>";
    this.licenceContent+="<p class='text'>24.2 平台不保证服务结果一定满足用户需求，也不对通过本服务购买或获取的任何产品、服务、信息或其他材料的真实性、合法性、准确性作担保。</p>";
    this.licenceContent+="<p class='title2'><b>第25条 AI服务特殊性</b></p>";    
    this.licenceContent+="<p class='text'>25.1 用户理解并同意，AI技术仍在发展中，本平台提供的AI服务可能存在不准确、不完整或不及时的情况。</p>";
    this.licenceContent+="<p class='text'>25.2 对于AI生成的内容，用户应在使用前进行核实，特别是在涉及重要决策的场景下。平台不对因依赖AI生成内容而导致的任何损失承担责任。</p>";
    this.licenceContent+="<p class='title2'><b>第26条 第三方责任</b></p>";
    this.licenceContent+="<p class='text'>26.1 用户因使用本服务而与第三方产生纠纷的，平台不承担任何责任。</p>";
    this.licenceContent+="<p class='text'>26.2 用户通过本服务与第三方进行的任何交易，平台不参与也不承担任何责任。</p>";
    this.licenceContent+="<p class='title2'><b>第27条 不可抗力</b></p>";
    this.licenceContent+="<p class='text'>27.1 因不可抗力（如自然灾害、战争、动乱、政府行为、网络攻击、病毒入侵等）导致服务中断或数据丢失的，平台不承担赔偿责任。</p>";
    this.licenceContent+="<p class='text'>27.2 平台将尽合理努力减少不可抗力造成的损失，并在不可抗力消除后尽快恢复服务。</p>";
    this.licenceContent+="<p class='title2'><b>第九章 违约责任</b></p>";
    this.licenceContent+="<p class='title2'><b>第28条 违约认定</b></p>";
    this.licenceContent+="<p class='text'>28.1 用户违反本协议约定的，平台有权独立判断并视情况采取警告、限制或终止服务、追究法律责任等措施。</p>";
    this.licenceContent+="<p class='text'>28.2 用户的行为导致平台或第三方遭受损失的，用户应承担全部赔偿责任。</p>";
    this.licenceContent+="<p class='title2'><b>第29条 平台违约</b></p>";
    this.licenceContent+="<p class='text'>29.1 如因平台原因导致用户无法正常使用服务，平台应尽快修复。</p>";
    this.licenceContent+="<p class='text'>29.2 平台违约的赔偿上限不超过用户已支付的服务费用。</p>";
    this.licenceContent+="<p class='title1'><b>第十章 协议终止</b></p>";
    this.licenceContent+="<p class='title2'><b>第30条 终止权利</b></p>";
    this.licenceContent+="<p class='text'>30.1 租户终止服务（即“注销租户”）应与个人用户注销账户区分管理。租户终止服务须由租户法定代表人或经法定代表人书面授权的代表发起，并按平台要求提交加盖公章的《租户终止服务申请书》。</p>";
    this.licenceContent+="<p class='text'>30.2 <b>租户（企业/组织/个人）</b> 如需终止服务并注销租户，应提交书面申请（包括但不限于上传加盖公章的终止服务申请书），经平台审核通过后方可执行。租户管理员无权单独决定注销租户。</p>";    
    this.licenceContent+="<p class='text'>30.3 平台有权基于运营需要终止提供全部或部分服务，但应提前通知用户。</p>";
    this.licenceContent+="<p class='title2'><b>第31条 租户终止服务</b></p>";
        this.licenceContent+="<p class='text'>31.1 租户终止服务（即“注销租户”）应与个人用户注销账户区分管理。租户终止服务须由租户法定代表人或经法定代表人书面授权的代表发起，并按平台要求提交加盖公章的《租户终止服务申请书》。</p>";
        this.licenceContent+="<p class='text'>31.2 租户可选择以下数据处置方式：</p>";
        this.licenceContent+="<p class='text'>（a）全部删除；</p>";
        this.licenceContent+="<p class='text'>（b）仅删除个人信息，业务数据归档；</p>";
        this.licenceContent+="<p class='text'>（c）全部导出后删除。</p>";
        this.licenceContent+="<p class='text'>但无论租户选择何种方式，平台依法应当保留下列记录不予删除：</p>";
        this.licenceContent+="<p class='text'>（a）用于会计核算、税务申报、发票管理的交易、支付、结算及发票记录；</p>";
        this.licenceContent+="<p class='text'>（b）网络运行日志、安全事件日志、身份认证日志（留存不少于六个月或按等级保护测评的相关要求）；</p>";
        this.licenceContent+="<p class='text'>（c）账号与权限变更、数据导出、注销申请、审核及删除执行等平台审计记录；</p>";
        this.licenceContent+="<p class='text'>（d）法律法规、监管要求或合同约定须保留的其他记录。";
        this.licenceContent+="<p class='text'>上述保留数据仅用于合规、审计、争议处理与安全溯源，平台应采取访问控制与脱敏措施。</p>";
        this.licenceContent+="<p class='text'>31.3 租户终止服务申请提交后，平台设有7日冷静期。冷静期内，租户可撤回申请。</p>";
        this.licenceContent+="<p class='text'>31.4 平台有权在以下情形下拒绝或延迟处理租户终止服务申请：</p>";
        this.licenceContent+="<p class='text'>（a）租户存在未结清费用或未履行完毕的合同义务；</p>";
        this.licenceContent+="<p class='text'>（b）租户涉及诉讼、仲裁或监管调查；</p>";
        this.licenceContent+="<p class='text'>（c）平台合理认为存在欺诈、盗用公章或其他风险。</p>";
        this.licenceContent+="<p class='text'>31.5 租户终止服务后，平台将按租户选择的方式处置数据。但法律法规要求保留的财务记录、审计日志等，平台有权依法保留。</p>";
        this.licenceContent+="<p class='text'>31.6  平台将按租户选择的方式处置数据。但平台不承诺提供自助恢复功能。</p>";
        this.licenceContent+="<p class='text'>31.7 如法律法规、司法机关或监管部门要求，平台有权在履行必要程序后恢复并提供归档数据。</p>";
        this.licenceContent+="<p class='text'>31.8 平台因自身过错导致数据错误归档的，应在收到租户有效请求后合理期限内予以恢复。</p>";
        this.licenceContent+="<p class='text'>31.9 租户选择“仅删除个人信息，业务数据归档”后，平台将业务数据转入冷存储，租户不再享有在线访问、查询、修改或恢复的权利。</p>";
        this.licenceContent+="<p class='text'>31.10 租户选择“全部删除”的，应确认已了解相关法律法规对数据留存的要求，并自愿承担因删除数据导致的一切法律后果。平台不承担因租户选择“全部删除”而产生的任何合规风险。平台有权在租户选择“全部删除”时，提示其所在行业的法定留存要求，但最终选择权归租户所有。</p>";
        this.licenceContent+="<p class='text'>31.11 归档数据仅用于满足法律法规要求的留存义务，以及应对司法、监管部门的调阅需求。</p>";
     
        this.licenceContent+="<p class='title2'><b>第32条 终止后处理</b></p>";
        this.licenceContent+="<p class='text'>32.1 协议终止后，平台有权保留法律法规要求必须保留的数据（如财务凭证、审计日志等），并在法定保留期限届满后予以删除或匿名化处理。</p>";
        this.licenceContent+="<p class='text'>32.2 对于租户要求删除的个人信息及其他非强制保留的业务数据，平台应在租户完成合法注销流程后，按租户选定的数据处置方式执行。</p>";   
        this.licenceContent+="<p class='text'>32.3 租户完成注销后，其业务数据自助导出入口将关闭。如租户因合规审计、法律诉讼、监管检查等正当理由，需调阅平台依规保留的归档数据（包括但不限于操作日志、登录日志、审核记录、计费明细），可向平台提交书面申请，说明调阅范围及用途。平台审核通过后，将在合理期限内提供必要范围的脱敏副本。涉及个人信息的部分，平台将依法进行脱敏处理。如调阅超出系统自动检索范围，需人工介入处理，平台可收取合理成本费用，并在受理前向租户明示收费标准。</p>";                                            
        this.licenceContent+="<p class='text'>32.4 协议终止后，平台没有义务向用户或第三方披露任何数据，但以下情形除外：</p>"; 
        this.licenceContent+="<p class='text'>（a）用户在注销前已自行导出并确认数据完整；</p>"; 
        this.licenceContent+="<p class='text'>（b）法律法规、司法机关或监管部门要求平台提供；</p>"; 
        this.licenceContent+="<p class='text'>（c）平台为维护自身合法权益需要保留或使用的数据。</p>";         

    this.licenceContent+="<p class='title1'><b>第十一章 法律适用与争议解决</b></p>";
    this.licenceContent+="<p class='title2'><b>第33条 法律适用</b></p>";
    this.licenceContent+="<p class='text'>33.1 本协议的订立、执行、解释及争议解决均适用中华人民共和国法律（不含香港、澳门和台湾地区法律）。</p>";
    this.licenceContent+="<p class='title2'><b>第34条 争议解决</b></p>";
    this.licenceContent+="<p class='text'>34.1 因本协议引起的或与本协议有关的任何争议，双方应首先通过友好协商解决。协商不成的，任何一方均有权将争议提交平台运营方所在地有管辖权的人民法院诉讼解决。</p>";

    this.licenceContent+="<p class='title1'><b>第十二章 其他规定</b></p>";
    this.licenceContent+="<p class='title2'><b>第35条 通知送达</b></p>";
    this.licenceContent+="<p class='text'>35.1 平台对于用户所有的通知均可通过网页公告、电子邮件、手机短信或其他常规的信件传送等方式进行。</p>";
    this.licenceContent+="<p class='text'>33.2 通知于发送之日视为已送达收件人。</p>";
    this.licenceContent+="<p class='title2'><b>第36条 可分割性</b></p>";
    this.licenceContent+="<p class='text'>36.1 如本协议中的任何条款因任何原因被认定为无效或不可执行，该条款应在必要的最小范围内受限，其余条款仍应保持完全有效。</p>";
    this.licenceContent+="<p class='title2'><b>第37条 完整协议</b></p>";
    this.licenceContent+="<p class='text'>37.1 本协议构成双方就使用本服务所达成的完整协议，取代双方先前就本协议标的所达成的任何口头或书面协议。</p>";   
    this.licenceContent+="<p class='title2'><b>第38条 权利保留</b></p>";
    this.licenceContent+="<p class='text'>38.1 平台未行使本协议项下的任何权利不构成对该权利的放弃</p>";
    
    this.licenceContent+="<p class='title1'><b>附则</b></p>";
    this.licenceContent+="<p class='title2'><b>第39条 协议生效</b></p>";
    this.licenceContent+="<p class='text'>39.1 本协议自用户同意之日起生效，至协议终止或用户注销账户之日止。</p>";
    this.licenceContent+="<p class='title2'><b>第40条 联系方式</b></p>";
    this.licenceContent+="<p class='text'>40.1 如用户对本协议或本服务有任何疑问，可通过平台公示的联系方式与我们联系。</p>";
    this.licenceContent+="<p class='text' style='margin-left:530px;'>协议最后更新日期：2026年08月01日</p>";
    this.licenceContent+="<p class='text' style='margin-top:20px;'><b>重要提示：</b>本协议内容较多，为保障您的权益，请在同意前仔细阅读各条款，特别是加粗显示的条款。如您不同意本协议的任何内容，请立即停止使用本服务。</p>";


    this.privacyContent="<p class='title1'><b>引言</b></p>";
    this.privacyContent+="<p class='text'>欢迎您使用小晖AI客服平台（以下简称\"本平台\"）。</p>";
    this.privacyContent+="<p class='text'>本《隐私政策》（以下简称“本政策”）由北京启明晨晖信息技术有限公司（以下简称“我们”或“平台”）制定，旨在清晰透明地说明当您作为<b>最终用户</b>（即使用我们平台服务的个人、企业或组织）或作为<b>平台直接用户</b>（即该企业或组织的管理员或员工用户）时，我们如何收集、使用、存储、保护和处理您的个人信息。</p>";
    this.privacyContent+="<p class='text'><b>我们的角色定位：</b></p>";
    this.privacyContent+="<p class='text'>•	对于<b>平台直接用户</b>（企业或组织的管理员或员工用户），我们是您的“个人信息处理者”。</p>";
    this.privacyContent+="<p class='text'>•	对于<b>最终用户</b>（咨询客户），我们通常是受您所接洽的企业或组织（我们的客户）委托的“受托方”，代表他们处理您的信息。我们的客户是决定处理您信息的目的和方式的“个人信息处理者”。</p>";
    this.privacyContent+="<p class='text'><b>请务必仔细阅读、理解本政策。一旦您开始使用本平台提供的服务，或通过我们客户部署的客服渠道进行咨询，即表示您已同意我们按照本政策处理您的个人信息。如您不同意本政策内容，请立即停止使用或访问我们的服务。</b></p>";
    
    this.privacyContent+="<p class='title1'><b>一、我们如何收集您的个人信息</b></p>";
    this.privacyContent+="<p class='text'>个人信息是指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息。</p>";
    this.privacyContent+="<p class='title2'><b>1.1 您直接向我们提供的信息 </b></p>";    
    this.privacyContent+="<p class='text'>•	<b>注册账号信息</b>：当您作为平台直接用户注册账号时，可能需要提供手机号码、电子邮箱地址、姓名、职位等信息，并设置密码。</p>";
    this.privacyContent+="<p class='text'>•	<b>联系信息</b>：当您通过我们的官网、邮箱、电话等渠道联系我们时，可能会提供您的<b>姓名、联系方式、工作单位</b>等信息。</p>";
    this.privacyContent+="<p class='title2'><b>1.2 在使用服务过程中产生的信息  </b></p>";    
    this.privacyContent+="<p class='text'>•	<b>设备与日志信息</b>：当您访问或使用我们的服务时，我们会自动收集必要的设备信息和日志信息，包括：</p>";
        this.privacyContent+="<p class='text' style='margin-left:50px'>◎ <b>设备信息</b>：如设备型号、操作系统版本、唯一设备标识符（如Android ID）、浏览器类型、IP地址。</p>";
        this.privacyContent+="<p class='text' style='margin-left:50px'>◎ <b>日志信息</b>：如操作时间、访问时长、点击记录、崩溃信息。</p>";
        this.privacyContent+="<p class='text'>•	<b>客服交互信息</b>：当您作为最终用户使用我们客户的客服服务时，我们会根据客户的设置和处理要求，处理您与客服之间的<B>对话内容、上传的图片或文件</b>，以及为提供服务所必需的身份标识信息（如订单号、用户ID）。</p>";

    this.privacyContent+="<p class='title2'><b>1.3 从第三方获取的信息 </b></p>";    
    this.privacyContent+="<p class='text'>在法律允许的情况下，我们可能从第三方合作伙伴（如通过账号授权登录）处获取您的信息，但会要求第三方说明其个人信息来源，并保证其收集、提供行为的合法性。</p>";


    this.privacyContent+="<p class='title1'><b>二、我们如何使用您的个人信息 </b></p>";
    this.privacyContent+="<p class='text'>我们将基于以下目的使用您的个人信息：</p>";
    this.privacyContent+="<table style='width:800px;border:1px solid #aaaaaa; border-collapse:collapse' border='1'><tr><td style='width:150px; text-align: center'><b>使用目的</b/></td><td style='width:250px; text-align: center'><b>涉及的个人信息</b></td><td style='text-align: center'><b>法律依据</b></td></tr>";
    this.privacyContent+="<tr><td><b>向您提供核心客服功能</b></td><td>账号信息、设备信息、客服交互内容</td><td>履行合同必需</td></tr>";
    this.privacyContent+="<tr><td><b>保障服务安全与质量</b></td><td>设备信息、日志信息、操作记录</td><td>履行合同及我们的正当利益（如反欺诈、优化服务）</td></tr>";
    this.privacyContent+="<tr><td><b>发送服务通知</b></td><td>账号信息、联系方式</td><td>履行合同必需（如重要功能变更通知）</td></tr>";
    this.privacyContent+="<tr><td><b>遵守法律法规</b></td><td>根据法律法规要求可能涉及的任何信息</td><td>遵守法定义务</td></tr>";
    this.privacyContent+="</table>";
    this.privacyContent+="<p class='text'><b>请注意</b>：对于最终用户的交互信息，其使用目的主要由我们的客户（即您所咨询的企业或组织）决定。我们仅根据与客户签订的协议，代表客户处理这些信息以提供客服服务。关于他们如何处理您的信息，请查阅其独立的隐私政策。</p>";

    this.privacyContent+="<p class='title1'><b>三、我们如何使用Cookie和同类技术 </b></p>";
    this.privacyContent+="<p class='text'>1. <b>Cookie</b>：为确保网站正常运转，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。我们使用Cookie的主要目的是：</p>";
    this.privacyContent+="<p class='text' style='margin-left:50px'>◎ <b>保障服务安全</b>：验证您的身份，监测欺诈行为。</p>";
    this.privacyContent+="<p class='text' style='margin-left:50px'>◎ <b>个性化体验</b>：记住您的偏好设置。</p>";
    this.privacyContent+="<p class='text'>2. <b>控制Cookie：</b>您有权选择是否接受Cookie。您可以通过浏览器设置管理或删除Cookie。但请注意，如果停用Cookie，您可能无法享受最佳的服务体验，某些服务也可能无法正常使用。</p>";


    this.privacyContent+="<p class='title1'><b>四、我们如何共享、转让、公开披露您的个人信息 </b></p>";
    this.privacyContent+="<p class='text'>我们高度重视您的个人信息安全，<b>不会与任何公司、组织和个人共享、转让或公开披露您的个人信息</b>，但以下情况除外：</p>";
    this.privacyContent+="<p class='title2'><b>4.1 共享 </b></p>";
    this.privacyContent+="<p class='text'>•	 <b>征得您的明确同意后。</b></p>";
    this.privacyContent+="<p class='text'>•	 <b>与我们的关联公司共享</b>: 仅为实现本政策声明的目的，在关联公司间遵循本政策。</p>";
    this.privacyContent+="<p class='text'>•	 <b>与授权合作伙伴共享</b>: 我们可能委托第三方（如云服务器提供商、数据分析服务商、AI模型提供商）提供技术支持。我们会与这些合作伙伴签订严格的数据处理协议，要求他们按照本政策采取保密和安全措施处理个人信息。</p>";
    this.privacyContent+="<p class='text'>•	 <b>应法律要求或保护权利所需</b>: 如为遵守法律程序、执行相关服务条款或保护我们及其他用户的权利、财产或安全。</p>";
    this.privacyContent+="<p class='title2'><b>4.2 转让</b></p>";    
    this.privacyContent+="<p class='text'>我们不会将您的个人信息转让给任何公司、组织或个人，除非在涉及合并、收购或破产清算时，且受让方承诺继续受本政策约束。</p>";
    this.privacyContent+="<p class='title2'><b>4.3 公开披露</b></p>";    
    this.privacyContent+="<p class='text'>我们仅在获得您明确同意或法律强制要求的情况下，才会公开披露您的个人信息。</p>";


    this.privacyContent+="<p class='title1'><b>五、我们如何保护和存储您的个人信息 </b></p>";
    this.privacyContent+="<p class='title2'><b>5.1 安全保护措施</b></p>";
    this.privacyContent+="<p class='text'>我们已采取符合业界标准的安全防护措施，包括：</p>";
    this.privacyContent+="<p class='text'>•	 <b>技术措施</b>：如加密传输（HTTPS/SSL）、数据脱敏、访问控制、安全审计。</p>";
    this.privacyContent+="<p class='text'>•	 <b>管理措施</b>：与员工和供应商签订保密协议，定期进行安全培训。</p>";
    this.privacyContent+="<p class='text'>•	 <b>组织措施</b>: 设立数据保护负责人或团队，负责个人信息安全事务。</p>";    
    this.privacyContent+="<p class='text'>尽管已采取合理措施，但请注意，任何安全措施都无法做到百分百安全。我们将尽力确保您个人信息的安全性。</p>";  

    this.privacyContent+="<p class='title2'><b>5.2 信息存储</b></p>";
    this.privacyContent+="<p class='text'>•	 <b>存储地点</b>: 我们将在中国大陆境内运营和存储您的数据，存儲数据的服务器设在中国大陆境内。</p>";
     this.privacyContent+="<p class='text'>•	 <b>存储期限</b>: 我们仅在为实现本政策所述目的所必需的期间内保留您的个人信息，除非法律要求或允许更长的保留期。对于平台直接用户，信息保留至账号注销后必要的合规期限；对于最终用户的交互信息，其存储期限由我们的客户决定，我们按指令执行。</p>";
 


    this.privacyContent+="<p class='title1'><b>六、您的权利</b></p>";
    this.privacyContent+="<p class='text'>您有权行使法律赋予您的个人信息权利，包括：</p>";
    this.privacyContent+="<p class='text' style='margin-left:10px'>•	 <b>访问、更正您的个人信息</b>: 您可以访问和编辑您的账户信息。</p>";
    this.privacyContent+="<p class='text' style='margin-left:10px'>•	 <b>删除个人信息</b>: 在特定情况下，您可以要求我们删除个人信息。</p>";
    this.privacyContent+="<p class='text' style='margin-left:10px'>•	 <b>撤回同意</b>: 您可以通过注销账号、调整设备权限等方式撤回已同意的授权。撤回后，不影响此前基于授权已进行的个人信息处理活动的效力。</p>";
    this.privacyContent+="<p class='text' style='margin-left:10px'>•	 <b>注销账号</b>: 您可以通过「账号设置」中的功能申请注销账号。注销后，我们将停止为您提供产品与服务，并根据适用法律的要求删除您的个人信息或进行匿名化处理。</p>";
    this.privacyContent+="<p class='text'><b>对于最终用户</b>：由于您的信息主要由我们的客户（即您咨询的企业或组织）控制，如您需要行使上述权利，请直接联系该企业。我们将协助他们响应您的请求。</p>";    


    this.privacyContent+="<p class='title1'><b>七、我们如何处理儿童的个人信息 </b></p>";
    this.privacyContent+="<p class='text'>我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，儿童不应创建自己的用户账户。</p>";
    this.privacyContent+="<p class='text'>如果我们发现自己在未获得可证实的父母同意的情况下收集了儿童的个人信息，我们会设法尽快删除相关数据。如果您认为我们错误或意外地向儿童收集了信息，请立即联系我们。</p>";    


    this.privacyContent+="<p class='title1'><b>八、本政策如何更新</b></p>";
    this.privacyContent+="<p class='text'>我们可能适时修订本政策。当条款发生重大变更时，我们将通过平台公告、站内通知等显著方式通知您。变更后的政策将在通知指定的正式生效日期起生效。</p>";
    this.privacyContent+="<p class='text'><b>重大变更包括但不限于：</b></p>";    
    this.privacyContent+="<p class='text'>1. 我们的服务模式发生重大变化；</p>";    
    this.privacyContent+="<p class='text'>2.	个人信息共享、转让或公开披露的主要对象发生变化；</p>";    
    this.privacyContent+="<p class='text'>3.	您参与个人信息处理的权利及行使方式发生重大变化。</p>";        this      

    this.privacyContent+="<p class='title1'><b>九、如何联系我们</b></p>";
    this.privacyContent+="<p class='text'>如果您对本政策有任何疑问、意见或建议，或希望行使您的相关权利，请通过以下方式与我们联系：</p>";
    this.privacyContent+="<p class='text'><b>•	 运营方名称：</b>北京启明晨晖信息技术有限公司</p>";    
    this.privacyContent+="<p class='text'><b>•	 邮箱； </b> support@bj-sunrise.net</p>";    
    this.privacyContent+="<p class='text'>一般情况下，我们将在<b>15个工作日内</b>予以回复。</p>";         


    this.acceptableContent="<p class='title1'><b>小晖AI客服平台可接受使用政策</b></p>";    
    this.acceptableContent+="<p class='title2'><b>引言</b></p>";
    this.acceptableContent+="<p class='text'>欢迎使用小晖AI客服平台（以下简称“本平台”）。</p>";
    this.acceptableContent+="<p class='text'>本《可接受使用政策》（以下简称“本政策”）是您与平台运营方（以下简称“我们”）之间签订的《用户服务协议》的重要组成部分。本政策旨在明确所有用户在使用本平台服务时必须遵守的规范和义务，以维护平台的安全、稳定与所有用户的共同利益。</p>";
    this.acceptableContent+="<p class='text'><b>请务必仔细阅读并理解本政策。一旦您以任何方式使用本平台服务，即表示您已完全接受并同意遵守本政策的全部条款。如果您不同意本政策的任何内容，请立即停止使用本平台服务。</b>我们保留根据法律法规要求或业务发展需要，随时更新本政策的权利。更新后的政策将通过平台公告等方式通知您，并于发布后生效。</p>";

    this.acceptableContent+="<p class='title2'><b>一、总则 </b></p>";
    this.acceptableContent+="<p class='text'>1.1 本政策适用于所有使用本平台服务的用户，包括但不限于租户管理员、租户员工用户、客服人员以及通过本平台与上述用户交互的最终用户。</p>";
    this.acceptableContent+="<p class='text'>1.2 您有责任确保您的员工、代理人及其他经您授权使用本服务的任何个人（以下简称“授权用户”）同样遵守本政策。您需对授权用户违反本政策的行为承担全部责任。</p>";
    this.acceptableContent+="<p class='text'>1.3 您理解并同意，您使用本平台服务的行为必须同时遵守您所属国家/地区、我们所在国家/地区以及服务涉及的其他相关国家/地区的法律法规。</p>";

    this.acceptableContent+="<p class='title2'><b>二. 可接受使用准则 </b></p>";
    this.acceptableContent+="<p class='text'>您承诺将本平台用于合法、正当的目的，并尤其遵守以下准则：</p>";
    this.acceptableContent+="<p class='text'>2.1 <b>合法合规</b>：确保您的使用行为符合所有适用的法律、法规、规章和行业标准。</p>";    
    this.acceptableContent+="<p class='text'>2.2 <b>诚实信用</b>：提供真实、准确、完整的信息，不进行任何欺诈或误导性行为。</p>";
    this.acceptableContent+="<p class='text'>2.3 <b>尊重他人</b>：尊重其他用户及您的客户，不进行骚扰、诽谤、侮辱或任何形式的攻击。</p>";
    this.acceptableContent+="<p class='text'>2.4 <b>责任自负</b>：您应对通过您的账户进行的所有活动负全部责任，并对您在本平台创建、存储、传输的内容（包括但不限于知识库、对话记录、上传文件等）的合法性、真实性、准确性负责。</p>";

    
    this.acceptableContent+="<p class='title2'><b>三. 禁止内容</b></p>";
    this.acceptableContent+="<p class='text'>您不得使用本平台创建、存储、传输或分享任何包含以下内容的信息：</p>";
    this.acceptableContent+="<p class='text'>3.1 <b>违禁内容</b>：反对宪法所确定的基本原则的；危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；损害国家荣誉和利益的；煽动民族仇恨、民族歧视，破坏民族团结的；破坏国家宗教政策，宣扬邪教和封建迷信的。</p>";    
    this.acceptableContent+="<p class='text'>3.2 <b>非法与有害内容</b>: 散布谣言，扰乱社会秩序，破坏社会稳定的；散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；侮辱或者诽谤他人，侵害他人合法权益的；含有法律、行政法规禁止的其他内容的。</p>";
    this.acceptableContent+="<p class='text'>3.3 <b>侵权内容</b>: 侵犯他人知识产权（如著作权、专利权、商标权）、商业秘密、隐私权、肖像权等合法权益的内容。</p>";
    this.acceptableContent+="<p class='text'>3.4 <b>恶意内容</b>：含有计算机病毒、木马程序、恶意代码，或任何可能破坏、干扰、秘密截取任何系统、数据或个人信息的其他软件或程序。</p>";
    this.acceptableContent+="<p class='text'>3.5 <b>欺诈内容</b>：用于网络钓鱼、诈骗，或传播虚假、误导性信息的内容。</p>";

    this.acceptableContent+="<p class='title2'><b>四. 禁止行为</b></p>";
    this.acceptableContent+="<p class='text'>您在使用本平台服务时，不得从事以下任何行为：</p>";
    this.acceptableContent+="<p class='text'>4.1 <b> 系统攻击</b>: 尝试探测、扫描、测试本平台系统或网络的漏洞；发起拒绝服务攻击（DDoS）或其它任何形式的网络攻击。</p>";    
    this.acceptableContent+="<p class='text'>4.2 <b>未经授权的访问</b>: 试图避开、破坏或禁用本平台的安全功能；未经授权访问本平台、其他用户的账户、数据或系统。</p>";
    this.acceptableContent+="<p class='text'>4.3 <b>干扰服务</b>: 进行任何可能对本平台基础设施造成不合理或不成比例的大负荷的行为；干扰或破坏本平台的服务、服务器或网络。</p>";
    this.acceptableContent+="<p class='text'>4.4 <b>恶意自动化</b>：在未经我们明确许可的情况下，使用任何机器人、蜘蛛、爬虫等自动化手段访问或使用本平台。</p>";
    this.acceptableContent+="<p class='text'>4.5 <b>反向工程</b>：对本平台提供的软件进行反向工程、反编译、反汇编，或试图提取源代码。</p>";
    this.acceptableContent+="<p class='text'>4.6 <b>滥用AI功能</b>：恶意引导AI客服生成违法、违规或不道德的内容；利用AI功能进行大规模垃圾信息发送或其它滥用行为。</p>";
        
    this.acceptableContent+="<p class='title2'><b>五. 违规处理 </b></p>";
    this.acceptableContent+="<p class='text'>如果我们发现或合理怀疑您违反了本政策，我们有权根据违规行为的严重程度，采取一项或多项措施，而无需提前通知：</p>";
    this.acceptableContent+="<p class='text'>5.1 <b>警告</b>:向您发出警告，要求限期整改。</p>";    
    this.acceptableContent+="<p class='text'>5.2 <b>限制功能</b>: 暂停或终止部分或全部服务功能。</p>";
    this.acceptableContent+="<p class='text'>5.3 <b>内容处置</b>: 删除或屏蔽违规内容</p>";
    this.acceptableContent+="<p class='text'>5.4 <b>终止服务</b>: 立即终止向您提供全部服务，注销您的账户。</p>";
    this.acceptableContent+="<p class='text'>5.5 <b>追究责任</b>：如果我们认为必要，我们将向主管机关报告违规行为，并配合调查。您应承担因违规行为所引起的一切法律责任。</p>";
  
    this.acceptableContent+="<p class='title2'><b>六. 举报与联系我们</b></p>";
    this.acceptableContent+="<p class='text'>我们鼓励用户共同维护良好的平台环境。如果您发现任何违反本政策的行为或内容，请立即通过以下方式联系我们进行举报。我们将及时进行调查和处理。</p>";
    this.acceptableContent+="<p class='text'>•	<b>举报邮箱</b>：support@bj-sunrise.net</p>";    
    this.acceptableContent+="<p class='text'>•	<b>联系客服</b>:通过平台内置的客服系统（点击AI客服对话窗口底部的【找人工】图标）</p>";
    this.acceptableContent+="<p class='text'>为便于调查，请在举报时尽可能提供详细的信息，如违规内容截图、链接、违规账户名称以及相关说明。</p>";
  
    this.acceptableContent+="<p class='title2'><b>七. 免责声明</b></p>";
    this.acceptableContent+="<p class='text'>您理解并同意，我们无法对所有用户生成的内容和行为进行即时、全面的监控。因此，您应对您使用本服务时接触到的其他用户内容自行判断并承担所有风险。我们不对任何用户内容的准确性、完整性或合法性负责。</p>";
    this.acceptableContent+="<p class='title2'><b>八. 政策更新</b></p>";
    this.acceptableContent+="<p class='text'>我们保留随时更新本政策的权利。任何变更将在本平台上发布更新版本后生效。如果您在变更生效后继续使用本平台服务，即表示您接受修订后的政策。</p>";

    this.acceptableContent+="<p class='title2'></p>";
    this.acceptableContent+="<p class='title2'><b>感谢您花时间阅读本《可接受使用政策》。您的理解和合作是确保本平台为所有用户提供优质、安全服务的关键。</b></p>";
    */               
  },

  methods: {
    //服务协议对话框
    HandleLicense() {
      this.open_licence = true;
      this.licenceContent =getUserAgeement();
    },
    //隐私政策对话框
     HandlePrivacy() {
       this.open_acceptable = false
        this.open_privacy = true;
       this.privacyContent = getPrivacy()
    },
    HandleAcceptable(){
      this.open_acceptable = true
      this.acceptableContent = getAcceptable();
    },
      // 密码复杂度校验
  validatePassword() {
    const pwd = this.form.password;

    if (!pwd) {
      this.passwordError = '请输入密码';
      return false;
    }

    if (pwd.length < this.passwordRules.minLength) {
      this.passwordError = `密码至少需要${this.passwordRules.minLength}位`;
      return false;
    }

    if (pwd.length > this.passwordRules.maxLength) {
      this.passwordError = `密码最长${this.passwordRules.maxLength}位`;
      return false;
    }

    if (this.passwordRules.requireLetter && !/[a-zA-Z]/.test(pwd)) {
      this.passwordError = '密码需包含字母';
      return false;
    }

    if (this.passwordRules.requireNumber && !/\d/.test(pwd)) {
      this.passwordError = '密码需包含数字';
      return false;
    }

    this.passwordError = '';
    return true;
  },

  // 密码一致性校验
  validatePasswordMatch() {
    if (this.form.password !== this.form.confirmPassword) {
      this.passwordMatchError = '两次输入的密码不一致';
      return false;
    }
    this.passwordMatchError = '';
    return true;
  },

    isImageFile(file) {
      return file && file.type.match('image.*')
    },
    handleFileUpload(event) {
      const file = event.target.files[0]
      if (file) {
        // Validate file size (max 5MB)
        if (file.size > 5 * 1024 * 1024) {
          this.$message.error('文件大小不能超过5MB')
          return
        }

        this.form.licenceFile = file

        if (this.isImageFile(file)) {
          const reader = new FileReader()
          reader.onload = (e) => {
            this.previewImage = e.target.result
          }
          reader.readAsDataURL(file)
        } else {
          this.previewImage = null
        }
      }
    },
    removeFile() {
      this.form.licenceFile = null
      this.previewImage = null
      this.$refs.licenceFile.value = ''
    },
    validatePhone() {
      this.isPhoneValid = /^1[3-9]\d{9}$/.test(this.form.contactPhone)
      if (!this.isPhoneValid) {
        this.$message.error('请输入正确的手机号')
      }
      return this.isPhoneValid
    },
    async handleSubmit() {
  if (!this.validateForm()) return;
  if(!this.agreement){
    this.$message.error("请阅读并同意《小晖AI客服平台用户服务协议》、《小晖AI客服平台用户服务协议》和《隐私政策》");
    return;
  }

  this.loading_register = true;

  try {
    const formData = new FormData();
    //formData.append('companyName', this.form.companyName);
    //formData.append('socialCreditCode', this.form.socialCreditCode);
    formData.append('contactPhone', this.form.contactPhone);
    formData.append('smsCode', this.form.code);
    //formData.append('pwd', this.form.password);
    let websiteCode = process.env.VUE_APP_WEBSITE_CODE || 'SUNRISE-01'
    formData.append('websiteCode', websiteCode);


    const response = await postRegister(formData);

    console.log("rgister response:",response);

    if (response && response.data && response.data.code === 200) {
      const message = (response.data && response.data.message) || '注册成功';
      this.$message.success(message);
      this.$router.push('/');

    } else {
      const errorMsg = (response.data && response.data.message) || '注册失败';
      this.$message.error(errorMsg);
    }
  } catch (error) {
    const errorMsg = error || '注册失败';
    this.$message.error(errorMsg);
  } finally {
    this.loading_register = false;
  }
},
    validateForm() {
      if (!this.validatePhone()) {
        return false
      }
      if (!this.form.code || this.form.code.length !== 6) {
        this.$message.error('请输入6位验证码')
        return false
      }

      return true;
    },
    async sendSMSCode() {
      if (this.isCountingDown || !this.validatePhone()) return;

      try {
        this.loading_sms = true;
        const response = await send_sms_code(this.form.contactPhone)
        console.log(response);
        if (response.data &&response.status===200 && response.data.code === 200) {
          this.loading_sms = false;
          this.startCountdown();
          this.$message.success('验证码已发送');
          this.smsError = '';
        } else {
          this.smsError = (response.data && response.data.message) || '发送验证码失败';
          this.$message.error(this.smsError);
        }
      } catch (error) {
        this.smsError = (error.response && error.response.data && error.response.data.message) || '发送验证码失败';
        this.$message.error(this.smsError);
      }
    },
    startCountdown() {
    this.countdown = 60;
    localStorage.setItem('smsCountdown', Date.now() + 60000); // 存储过期时间

    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }

    this.countdownTimer = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        clearInterval(this.countdownTimer);
        localStorage.removeItem('smsCountdown');
      }
    }, 1000);
  },
  checkCountdown() {
    console.log('checkCountdown');
    const savedTime = localStorage.getItem('smsCountdown');
    console.log(savedTime);
    if (savedTime) {
      const remainingTime = Math.ceil((parseInt(savedTime) - Date.now()) / 1000);
      if (remainingTime > 0) {
        this.countdown = remainingTime;
        this.startCountdown();
      } else {
        localStorage.removeItem('smsCountdown');
      }
    }
  },

    beforeDestroy() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables.scss';
@import '@/styles/public-theme.scss';

.register-page {
  min-height: 100vh;
  background: $light-bg;

  .main-nav {
    background: rgba($space-blue, 0.9);
    padding: 20px 5%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .logo {
      display: flex;
      align-items: center;
      color: $pure-white;
      font-weight: bold;
      font-size: 1.3rem;


      .logo-symbol {
        font-family: 'Fira Code', monospace;
        color: $electric-blue;
        font-size: 1.8rem;
        margin-right: 10px;
        border-radius: 5%;
      }
    }
  }
}

.register-wrapper {
  position: relative;
  min-height: calc(100vh - 80px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 50px;
}

.register-card {
  position: relative;
  margin-top: 80px;
  z-index: 10;
  width: 100%;
  max-width: 800px;
  background: $pure-white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba($space-blue, 0.15);
  overflow: hidden;
  padding: 40px;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 5px;
    background: linear-gradient(90deg, $electric-blue, $tech-blue);
  }
}

.register-title {
  font-size: 1.1rem;
  margin-bottom: 10px;
  color: $tech-blue;
  text-align: center;
  font-weight: 600;
}


.form-group {
  display: flex;          // 使用 flex 布局
  align-items: center;   // 垂直居中
  margin-bottom: 10px;   // 保持原有的底部间距

  label {
    flex: 0 0 180px;     // 固定 label 宽度
    margin-bottom: 0;    // 移除原来的底部 margin
    padding-right: 15px; // label 和 input 之间的间距
    text-align: right;   // 文字右对齐（可选）
    font-weight: 500;
    color: #474747;
  }

  input {
    flex: 1;             // input 占据剩余空间
    padding: 12px 15px;
    border: 1px solid $gray-border;
    border-radius: 6px;
    font-size: 1rem;
    transition: all 0.3s;
    background: rgba(240, 244, 249, 0.5);

    &:focus {
      border-color: $electric-blue;
      box-shadow: 0 0 0 3px rgba($electric-blue, 0.2);
    }
  }
}

/* 特殊处理上传组件的布局 */
.upload-container {
  flex: 1; // 上传组件占据整行

  label { // 上传标签的特殊处理
    flex: none;
    width: auto;
    text-align: left;
    padding-right: 0;
  }
}

/* 响应式调整 - 小屏幕恢复垂直布局 */
@media (max-width: 768px) {
  .form-group {
    flex-direction: column;
    align-items: flex-start;

    label {
      flex: none;
      width: 100%;
      text-align: left;
      padding-right: 0;
      margin-bottom: 8px;
    }
  }
}

.error-message {
  color: #ff4d4f;
  font-size: 0.85rem;
  margin-top: 5px;
}

.upload-container {
  width: 100%;
}

.file-input {
  display: none;
}

.upload-box {
  display: block;
  width: 100%;
  height: 120px;
  border: 2px dashed $gray-border;
  border-radius: 8px;
  background-color: rgba(240, 244, 249, 0.5);
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  overflow: hidden;

  &:hover {
    border-color: $electric-blue;
    background-color: rgba($electric-blue, 0.05);
  }
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #999;
}

.plus-icon {
  font-size: 2rem;
  font-weight: lighter;
  margin-bottom: 8px;
  color: $electric-blue;
}

.upload-text {
  font-size: 0.9rem;
}

.file-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 20px;
  position: relative;
}

.thumbnail {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.file-icon {
  font-size: 1.5rem;
  margin-right: 10px;
}

.file-name {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 30px;
}

.remove-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #ff4d4f;
  color: white;
  border: none;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &:hover {
    background: #ff7875;
  }
}

.sms-group {
  display: flex;
  align-items: center;
  gap: 10px;

  input {
    flex: 1;
    min-width: 0;
  }

  .sms-btn {
    background: $electric-blue;
    color: white;
    border: none;
    padding: 0 15px;
    height: 44px;
    border-radius: 6px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s;
    white-space: nowrap;

    &:disabled {
      background: #DDD;
      cursor: not-allowed;
    }

    &:not(:disabled):hover {
      background: darken($electric-blue, 10%);
    }
  }
}

.form-note {
  font-size: 0.85rem;
  color: #888;
  margin-top: 5px;
}

.password-group {
  display: flex;
  gap: 15px;
  margin-bottom: 25px;

  /* 移动端适配 */
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
  }

  /* 密码输入组的专属样式 */
  .password-input-group {
    flex: 1;
    position: relative; /* 为错误消息定位做准备 */

    label {
      display: block;
      margin-bottom: 8px;
    }

    input {
      width: 100%;
    }

    /* 错误消息样式 */
    .password-error-message {
      position: absolute; /* 绝对定位，不占用文档流空间 */
      bottom: -20px; /* 调整到输入框下方 */
      left: 0;
      width: 100%;
      color: #ff4d4f;
      font-size: 0.85rem;
      margin-top: 5px;
      white-space: nowrap;
    }

    /* 成功消息样式 */
    .password-success-message {
      position: absolute;
      bottom: -20px;
      left: 0;
      width: 100%;
      color: #52c41a;
      font-size: 0.85rem;
      margin-top: 5px;
      white-space: nowrap;
    }
  }
}

/* 移动端适配 */
@media (max-width: 768px) {
  .password-group {
    flex-direction: column; /* 小屏幕时恢复垂直布局 */
    gap: 10px;
  }
}
.submit-btn {
  background: $electric-blue;
  color: $pure-white;
  border: none;
  padding: 15px;
  width: 100%;
  font-size: 1.1rem;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 500;

  &:hover:not(:disabled) {
    background: darken($electric-blue, 10%);
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba($electric-blue, 0.4);
  }

  &:disabled {
    background: #DDD;
    cursor: not-allowed;
  }
}

.login-link {
  text-align: left;
  margin-top: 20px;
  color: #666;
  font-size: 0.95rem;


  a {
    color: $electric-blue;
    text-decoration: none;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }
}

@media (max-width: 768px) {
  .register-card {
    padding: 30px 20px;
  }

  .register-title {
    font-size: 1.5rem;
    margin-bottom: 20px;
  }

  .sms-group {
    flex-direction: column;
    gap: 10px;

    .sms-btn {
      width: 100%;
      height: 40px;
    }
  }
}
.link{
  color: $electric-blue;
  text-decoration: none;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
  cursor: pointer;
}
.required-asterisk {
    color: #ff4d4f; /* 红色 */
    margin-right: 4px;
  }
  .title1 {
    font-size: 1.0rem;
    font-weight: bold;
    font-family: weiruanyahei;
    text-align: left;
    color: #888;
    margin: 0;
  }
  title2{
    font-size: 0.9rem;
    font-weight: bold;
    font-family: weiruanyahei;
    text-align: left;
    color: #888;
    margin: 0;
  }
  .text{
    font-family: 'Courier New', Courier, monospace;
    font-size: 0.8rem;
    color: #888;
    text-indent: 20px; /* 设置首行缩进为20像素 */
    margin: 0;
 }

/* 隐藏原生复选框 */
input[type="checkbox"] {
  appearance: none;
  -webkit-appearance: none;
  width: 22px;
  height: 22px;
  border: 2px solid $electric-blue;
  border-radius: 4px;
  outline: none;
  cursor: pointer;
  vertical-align: middle;
  margin-right: 6px;
  position: relative;
  transition: all 0.2s;
}

/* 选中状态 - 背景色与 link 颜色一致 */
input[type="checkbox"]:checked {
  background-color: $electric-blue;
  border-color: $electric-blue;
}

/* 勾选对勾符号 */
input[type="checkbox"]:checked::after {
  content: "✓";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 16px;
  font-weight: bold;
}

/* 悬停效果 */
input[type="checkbox"]:hover {
  border-color: darken($electric-blue, 10%);
}
</style>